import { Injectable } from "@angular/core";
import { getActiveEditable, ListenerGroup, onKeyboardViewportChange } from "../shared/keyboard-viewport.util";
import { RpKeyboardStateService } from "../keyboard-state.service";
import { RpKeyboardFocusRevealService } from "../keyboard-focus-reveal.service";

// The focus-guard prevents WebKit's focus pan for taps, but pans still slip through paths it
// cannot intercept (keyboard accessory prev/next arrows, autofocus, programmatic focus like
// ng-select's fullscreen picker). A panned document while the keyboard is open shows as a white
// area, so scroll it back to 0 and bring the focused field into view.
// The app shell is fixed-height — document scrollY has no legitimate non-zero state, ever. With
// the keyboard CLOSED any leftover pan (e.g. one landing in the picker-close instant, which even
// survives reloads via Safari scroll restoration) is healed unconditionally.
@Injectable({ providedIn: 'root' })
export class RpKeyboardPanHealService {

    private listeners = new ListenerGroup();

    constructor(
        private keyboardState: RpKeyboardStateService,
        private focusReveal: RpKeyboardFocusRevealService,
    ) {
    }

    start(): void {
        if (this.listeners.active || typeof window === 'undefined' || !window.visualViewport) {
            return;
        }
        onKeyboardViewportChange(this.listeners, () => this.heal());
        this.heal();
    }

    private heal(): void {
        if (Math.round(window.scrollY) <= 0) {
            return;
        }
        if (!this.keyboardState.isKeyboardOpen) {
            window.scrollTo(0, 0);
            return;
        }
        const active = getActiveEditable();
        if (!active) {
            return;
        }
        window.scrollTo(0, 0);
        this.focusReveal.revealField(active);
    }
}
